<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Krtgnn/tc-custom/9781631941900.jpg?1728353143831" alt="This image is the cover for the book Strangers Among Us, Alberg & Cassandra"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Strangers Among Us, Alberg & Cassandra
      </h1>
      <p class="bookDescription body article font2">
        <b><b>A teenager is arrested for his parents’ murder in a Canadian seaside village in the acclaimed series that launched the Fox TV and Hulu</b> series<b> <i>Murder in a Small Town</i>.</b></b><br/><br/> Vancouver's “Sunshine Coast” is famous for its beautiful vistas, but closer inspection reveals a strong dose of dysfunction among its quaint villages. Eliot Gardener is maddeningly sullen as only an angry fourteen-year-old can be. He's also, apparently, a double-murderer, having whacked both of his parents with a machete. At least it’s an open and shut case for Canadian Mountie Karl Alberg. Or is it?<br/><br/> Eliot may be guilty, but what drove him to commit such a grisly crime? As Alberg tries to get the troubled boy to talk, he finds himself dealing with dysfunction in his own life. His former neighbor bears him some serious ill will. And he keeps popping up wherever Alberg happens to be. Suddenly Alberg is watching a number of simmering pots . . .and the tension is only heating up. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        L.R. Wright
      </h2>
      
      <p class="authorDescription body article">LR Wright was a Canadian writer and author of the Edgar-winning cult classic The Suspect, first in the “Karl Alberg” series of nine mystery novels set in a small town on the “Sunshine Coast” of Western Canada.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      FELONY & MAYHEM PRESS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?738063c2